import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { BenefitPlan } from '@app/models/benefits/benefit-plan.model';
import { BenefitPlan as EmployeeBenefitPlan } from '@app/models/employee/benefits/benefit-plan.model';

@Component({
    selector: 'app-switch-benefit-plan',
    templateUrl: './switch-benefit-plan.template.html',
})
export class SwitchBenefitPlanForm extends BaseForm {
    @Input() employeeBenefitPlan: EmployeeBenefitPlan;
    @Input() allBenefitPlans: BenefitPlan[] = [];

    @Output() selectedBenefitPlan: EventEmitter<BenefitPlan> = new EventEmitter<BenefitPlan>();

    newBenefitPlan: BenefitPlan;

    beforeShow(): void {
        this.newBenefitPlan = new BenefitPlan();
    }

    onBenefitPlanChange(): void {
        this.selectedBenefitPlan.emit(this.newBenefitPlan);
    }
}
